export default {"src":"/_next/static/media/red-heart-icon.c47e348a.svg","height":22,"width":22};